import React from 'react';
import styled from 'astroturf/react';

import { trackClick } from 'js/utils/trackClick';
import { Button } from 'js/design_system/Button';
import routes from 'js/core_pre_webpack/routes';

const Container = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm-24, 24px);
  border-radius: 6px;
  border: 2px solid var(--secondary-500, #4960d1);
  background: var(--White, #fff);
  width: 100%;
`;

const Title = styled.div`
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
`;

const Description = styled.div`
  color: #000;
  text-align: center;

  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

type Props = {
  pricingCopy: string;
};

const UpsellTestCard = ({ pricingCopy }: Props) => {
  const onClick = () => {
    trackClick({
      source: 'UpsellTestCard',
      extra: {},
    });
    window.location.href = routes.checkout_path({
      feature: 'upsell_mentions',
      from_navbar: false,
    });
  };

  return (
    <Container>
      <Title>See everything being said about you & your work</Title>
      <Description>
        Academia scans over 100 million papers and notifies you whenever your
        name is mentioned.
      </Description>
      <Button {...{ onClick }}>{`${pricingCopy} ▸`}</Button>
    </Container>
  );
};

export default UpsellTestCard;
